import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const Depoimentos = () => {
    const components = document.querySelectorAll('[data-component="depoimentos"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: true,
            pagination: {
                el: component.querySelector('.swiper-pagination-nav'),
                clickable: true, // permite clicar nos bullets
            },
            navigation: {
                nextEl: component.querySelector('.swiper-button-next'),
                prevEl: component.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1278: {
                    slidesPerView: 2,
                    spaceBetween: 264,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                }
            }
        });
    });
};

export default Depoimentos;

if (document.querySelectorAll('[data-component="depoimentos"]').length) {
    Depoimentos();
}
